import { useEffect, useState } from "react";
// import { Tooltip } from "react-tooltip";
import { v4 as uuidv4 } from "uuid";

interface MoriButtonProps {
  text: string;
  click?: any;
  ID?: string;
  active?: boolean;
  inMulti?: boolean;
  disabled?: boolean;
  icon?: any;
  isSubmit?: boolean;
  hideTextOnMobile?: boolean;
  activeBg?: string;
  customClass?: string;
  textCustomClass?: string;
  toolTipText?: string;
  TooltipStartDelay?: number;
  tooltipStyle?: object;
}

const MoriButton = ({
  text,
  click,
  ID,
  active,
  inMulti,
  icon,
  isSubmit,
  activeBg,
  disabled,
  toolTipText,
  tooltipStyle,
  TooltipStartDelay,
  customClass,
  hideTextOnMobile,
  textCustomClass,
}: MoriButtonProps) => {
  const [tooltipId, setTooltipId] = useState<string>(uuidv4());

  useEffect(() => {
    setTooltipId(uuidv4());
  }, []);

  const classHandler = () => {
    let cls =
      "!flex flex-row !items-center !justify-center bg-primary2 text-text2 text-[10px] rounded-[6px] py-2 px-3 cursor-pointer outline-none  whitespace-nowrap ";

    if (disabled) cls += "!bg-secondary2 !opacity-[0.6] ";

    if (inMulti) cls += "w-[100%] ";
    if (active) {
      cls += `!bg-primary3 flex justify-center items-center !text-secondary1 text-[14px] font-semibold opacity-[1] `;

      if (activeBg) cls += "!bg-secondary2 text-text1 ";
      else cls += "text-primary1 ";
    } else {
      cls += "opacity-[0.85] ";
    }

    if (isSubmit) cls += "bg-secondary2 text-text1 ";

    if (customClass) cls += `${customClass} `;
    return cls;
  };
  return (
    <>
      <button
        type={isSubmit ? "submit" : "button"}
        id={tooltipId}
        className={classHandler()}
        onClick={(e) => {
          if (disabled) return;
          if (e) e.preventDefault();
          if (click) click();
        }}
        data-tooltip-html={`<b>${toolTipText}</b>`}
        data-tooltip-delay-show={TooltipStartDelay ? TooltipStartDelay : 400}
      >
        {icon ? icon : null}

        <span
          className={`${hideTextOnMobile ? "hidden lg:flex" : ""} 
          ${textCustomClass ? textCustomClass : "!text-text3"}
          !m-0 !p-0 !leading-0 !text-[10px] !ml-1 relative top-[1px]`}
        >
          {text}
        </span>
      </button>

      {/* {toolTipText && !disabled ? (
        <Tooltip
          className="z-10  !rounded-[8px] !text-text1 !text-[10px] !leading-0"
          opacity={1}
          style={tooltipStyle ? tooltipStyle : null}
          anchorId={tooltipId}
          place={"bottom-start"}
          clickable
        />
      ) : null} */}
    </>
  );
};

export default MoriButton;
